"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Snapshot converter.
 *
 * @author Adam Drda
 */


var SnapshotConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SnapshotConverter, _DataObjectConverter_);

  function SnapshotConverter() {
    _classCallCheck(this, SnapshotConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SnapshotConverter).apply(this, arguments));
  }

  return SnapshotConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SnapshotConverter = SnapshotConverter;